// extracted by mini-css-extract-plugin
export default {"illustration":"coordinate_illustration__OgZEl"};